import axios from 'axios';

export default {
  getRoutingList({ commit }, list) {
    return new Promise((resolve, reject) => {
        axios({
        url: "/routing/list?order_by=created_on&order_dir=desc",
        params: {
          page: list.page || 0,
          routing_name: list.routing_name ? '*' + list.routing_name + '*' : '',
          per_page: list.perPage || '',
        },
        method: "GET"
        }).then(res => {
          resolve(res.data.payload);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  getRouting({ commit }, id) {
    return new Promise((resolve, reject) => {
        axios({
          url: "/routing/" + id,
          method: "GET"
        }).then(res => {
          commit('SET_ROUTING', res.data.payload);
          resolve(res.data.payload);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  postRouting({ commit }, routing) {
    return new Promise((resolve, reject) => {
        axios({
          url: "/routing",
          data: routing,
          method: "POST"
        })
        .then(res => {
          resolve(res.data.payload);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  deleteRouting({ commit }, id) {
    return  axios({
          url: "/routing/" + id,
          method: "DELETE"
        }).then(res => {
          return res.data.payload;
        }); 
  },
  editRouting({ commit }, { routing, id }) {
    return new Promise((resolve, reject) => {
        axios({
        url: "/routing/" + id,
        data: routing,
        method: "PATCH"
        })
        .then(res => {
          resolve(res.data.payload);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  addRoute({ commit }, route) {
    commit('ADD_ROUTE', route);
  },
  updateRoute({ commit }, { fields, index }) {
    commit('UPDATE_ROUTE', { fields, index })
  },
  removeRoute({ commit }, index) {
    commit('REMOVE_ROUTE', index);
  }
}